<template>
  <v-container class="component_main px-6">
    <v-row class="ma-0">
      <v-col class="" cols="12" sm="12" md="12">
        <h1>Gerenciar carteiras</h1>
        <p>Cadastre as carteiras e associe os operadores.</p>
      </v-col>
      <v-col class="py-0" cols="12" sm="12" md="5">
        <CarteirasForm 
          :sendForm="(form) => saveCarteira(form)"
          :acao="(item, acao) => emiteAcao(item, acao)"
          :grupoEconomico="grupoEconomico"
          :itemSelecionado="itemSelecionado"
          :associarGlosa="false"
          :apenasVer="apenasVer"
        />
      </v-col>
      <v-col class="py-0" cols="12" sm="12" md="7">
        <CarteirasList
          :list="carteirasList"
          :acao="(item, acao) => emiteAcao(item, acao)"
          :listResponsavel="listResponsavel"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import CarteirasForm from "@/components/recebiveis/carteiras/Form"
import CarteirasList from "@/components/recebiveis/carteiras/List"
export default {
  components: {
    CarteirasForm,
    CarteirasList
  },
  data() {
    return {
      apenasVer: false,
      carteirasList: [],
      itemSelecionado: null
    };
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      listResponsavel: (state) => state.recebiveis.listResponsavel
    }),
  },
  mounted() {
    this.getList()
  },
  methods: {
    emiteAcao(item, acao){
      this[acao](item)
    },
    saveCarteira(formData){
      this.itemSelecionado = formData
      let acao = formData.id? "updatecarteira" : "addcarteira" 
       let obj = {
          query: [{ 
            Modulo: "Carteira",
            Acao: acao,
            Payload: {grupo_economico: this.grupoEconomico, ...formData}
          }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if(!response || response.isAxiosError) {
          this.$store.commit("hideLoader")
          return
        }
        this.itemSelecionado = null
         let paramModal = {
                type: "success",
                title:  "Cadastro de carteira",
                message: acao == "updatecarteira"? "Atualização de carteira efetuada com sucesso." : "Adição de carteira  efetuada com sucesso",
                callback: null,
                btConfirm: { name: "ok", show: true, color: 'primary' },
                btCancel: { name: 'Cancelar', show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        this.getList()
      })
    },
    viewItem(item){
      this.itemSelecionado=item?{...item}:null
      this.apenasVer=true
    },
    editItem(item){
      this.itemSelecionado=item?{...item}:null
      this.apenasVer=false
    },
    getList() {
       let obj = {
          query: [{ 
            Modulo: "Carteira",
            Acao: "getcarteiras",
            Payload: {grupo_economico: this.grupoEconomico}
          }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if(!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.carteirasList = response.dados
      })
    },
    delItem(obj) {
      let opts = {
          query: [{ 
            Modulo: "Carteira",
            Acao: "deletecarteira",
            Payload: {grupo_economico: this.grupoEconomico, ...obj}
          }],
      }
      this.$store.dispatch("request/doRequest", opts).then(response => {
        if(!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.itemSelecionado = null
        this.getList()
      })
    },
  },
};
</script>

<style>
</style>